import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=1c32264f&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=1c32264f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c32264f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c32264f')) {
      api.createRecord('1c32264f', component.options)
    } else {
      api.reload('1c32264f', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=1c32264f&scoped=true&", function () {
      api.rerender('1c32264f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8fdbsM39x2cfq/JS/comp/DateRangeExt.vue"
export default component.exports